export default "__VITE_ASSET__a83f8c68__"